import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: '[app-tutorial-section-hider]',
  template: `
  `,
  standalone: true,
  host: {
    class: 'hider-overlay',
    '[class.hidden]': 'tutorialComplete || tutorialSteps.includes(currentTutorialStep)',
    '(click)': 'dismissOrNextTutorialStep()'
  }
})
export class TutorialSectionHider {
  @Input() tutorialComplete = false;
  @Input({ required: true }) tutorialSteps: string[] = [];
  @Input() currentTutorialStep = '';

  @Output() dismissOrNextTutorialStepEmitter = new EventEmitter<void>();
  constructor() {}

  dismissOrNextTutorialStep(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.dismissOrNextTutorialStepEmitter.emit();
  }
}

@Component({
  selector: 'app-tutorial-step',
  imports: [],
  templateUrl: './tutorial-step.component.html',
  styleUrl: './tutorial-step.component.scss',
  host: {
    class: 'tutorial auto-hide',
    '[class.right]': 'right',
    '[class.left]': 'left',
    '[class.center]': 'center',
    '[class.bottom-center]': 'bottom',
    '[class.hidden]': 'tutorialComplete || tutorialStep !== currentTutorialStep'
  }
})
export class TutorialStepComponent {
  @Input() noSteps = false;

  @Input() right = false;
  @Input() left = false;
  @Input() arrowUp = false;
  @Input() arrowDown = false;
  @Input() center = false;
  @Input() bottom = false;

  @Input() title = '';
  @Input() largeTitle = false;

  @Input() tutorialComplete = false;
  @Input({ required: true }) tutorialStep!: string;
  @Input() currentTutorialStep = '';
  @Input() currentTutorialStepIndex = 0;
  @Input() totalTutorialSteps = 0;

  @Output() dismissTutorialEmitter = new EventEmitter<void>();
  @Output() previousTutorialStepEmitter = new EventEmitter<void>();
  @Output() nextTutorialStepEmitter = new EventEmitter<void>();

  constructor() {}

  dismissTutorial(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.dismissTutorialEmitter.emit();
  }

  dismissOrNextTutorialStep(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.dismissTutorialEmitter.emit();
  }

  nextTutorialStep(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.nextTutorialStepEmitter.emit();
  }

  previousTutorialStep(event?: Event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    this.previousTutorialStepEmitter.emit();
  }
}
